import { render, staticRenderFns } from "./NavigationItemContent.vue?vue&type=template&id=d21e3aea&scoped=true&"
import script from "./NavigationItemContent.vue?vue&type=script&lang=ts&"
export * from "./NavigationItemContent.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItemContent.vue?vue&type=style&index=0&id=d21e3aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21e3aea",
  null
  
)

export default component.exports